<template lang="pug">
  .no-dead-end-ctas.container.xs-f-small.max-at-tweak(v-if="leftCta && leftCta.cta")
    .row
      .ctas-wrap.xs-12
        a.cta.left-cta(:href="leftCta.cta.url" @click.prevent="trackMREventAndRedirect(`NoDeadEndCtas - ${leftCta.cta.text} Clicked`, leftCta.cta.url)")
          .image-wrap
            img.full-width(:src="leftCta.image.url")
          span.inner-text.brand-color-1.semi-bold.upper.xs-f-xsmall.md-f-small.lg-f-xmedium.max-at-tweak {{ leftCta.cta.text }}
          .arrow-wrap.color-white.xs-f-xsmall.lg-f-small.max-at-tweak
            MrIcon(name="arrow-right" style="width:1em;")
        
        a.cta.right-cta(v-if="rightCta" :href="rightCta.cta.url" @click.prevent="trackMREventAndRedirect(`NoDeadEndCtas - ${rightCta.cta.text} Clicked`, rightCta.cta.url)")
          .image-wrap
            img.full-width(:src="rightCta.image.url")
          span.inner-text.brand-color-1.semi-bold.upper.xs-f-xsmall.md-f-small.lg-f-xmedium.max-at-tweak {{ rightCta.cta.text }}
          .arrow-wrap.color-white.xs-f-xsmall.lg-f-small.max-at-tweak
            MrIcon(name="arrow-right" style="width:1em;")

</template>

<script>
  import { mapState } from 'vuex';
  import MrIcon from '@components/MrIcon';

  export default {
    name: "NoDeadEndCtas",

    components: {
      MrIcon,
    },

    computed: {
      ...mapState('cms', ['cmsSettings']),
      ...mapState('customer', ['cdata']),

      settings() {
        if (this.$attrs.noDeadEndCtas) {
          return this.$attrs.noDeadEndCtas;
        }
        return this.cmsSettings?.noDeadEndCtas;
      },

      leftCta() {
        if (!this.bestMatch) {
          return this.settings?.TakeTheQuiz;
        } else {
          return this.settings?.ExploreAllShades;
        }
      },

      rightCta() {
        if (this.closestColorbar) {
          let cta = {...this.settings?.BookAppointment};
          cta.cta = {
            url: `/colorbar/booking/${this.closestColorbar}/services`,
            text: cta?.cta
          };
          return cta;
        }
        return null;
      },

      bestMatch() {
        return this.cdata.bestColorMatch;
      },

      closestColorbar() {
        return this.cdata?.closest_colorbar || this.cdata?.locationContext?.closestColorbar;
      }
    }
  };
</script>

<style scoped lang="stylus">
  .no-dead-end-ctas
    .ctas-wrap
      padding 2.5em 5%
      text-align center
      
      .cta
        position relative
        width 46%
        display inline-block
        vertical-align top
        border 1px solid #E4E0E9
        padding 1em
        text-align left
        
        .image-wrap
          display inline-block
          vertical-align top
          width 6em
          
          img
            vertical-align top
          
        .inner-text
          position absolute
          top 50%
          left 6.5em
          transform(translateY(-50%))
          width 55%
          
        .arrow-wrap
          position absolute
          top 50%
          right 1em
          background-color brand-color-1
          border-radius 1em
          padding 0 1em
          padding-bottom 0.2em
          margin-top -0.85em
          
      .left-cta
        margin-right 2%
        
      .right-cta
        margin-left 2%
        
    @media mq-mobile
      .ctas-wrap
        .cta
          width 100%
          margin 0
          margin-bottom 1em
          
          .image-wrap
            width 3.75em
          
          &:last-child
            margin-bottom 0
            
    @media mq-tablet
      .ctas-wrap
        .cta
          width 90%
          margin 0
          margin-bottom 1em
          
          .image-wrap
            width 4.5em
            
          .inner-text
            left 7em
          
          &:last-child
            margin-bottom 0
            
    @media mq-desktop-md
      .ctas-wrap
        .cta
          .image-wrap
            width 4.5em
          
</style>
